import { ReviewPaymentFormSubmitEvent } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsReviewPaymentComponentActions = createActionGroup({
  source: 'Hosted Payments Review Payment Component',
  events: {
    'Back To Select Payment Method': emptyProps(),
    'Review Payment Step Submitted': props<{
      event: ReviewPaymentFormSubmitEvent;
    }>(),
    'Payment Status Check Canceled': emptyProps(),
    'Component Initialized': emptyProps(),
    'Captcha Ready': emptyProps(),
  },
});
